import React from 'react';
import { useAuthStore } from '@/stores/auth-store';
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }: { children: React.JSX.Element }) => {
  const token = useAuthStore((state) => state.token);

  if (!token) {
    return <Navigate to="/login" />;
  }

  return children;
};
